import { Directive, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';

@Directive({
    selector: '[igDebounce]'
})
export class DebounceEventDirective implements OnInit {
    @Input() debounceTime = 800;
    @Output() debounceKeyup = new EventEmitter();
    private clicks = new Subject<any>();

    constructor() { }

    ngOnInit() {
        this.clicks
            .debounceTime(this.debounceTime)
            .subscribe(e => this.debounceKeyup.emit(e));
    }

    @HostListener('keyup', ['$event'])
    keyUpEvent(event: MouseEvent) {
        // event.preventDefault();
        // event.stopPropagation();
        this.clicks.next(event);
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/directives/debounce/debounce-event.directive.ts